// App.js
import React, { CSSProperties, useState, useEffect } from 'react';
import { loginRequest, msalInstance } from '../config/MsalConfig';
import microsoftLogo from '../assets/microsoft.png';


const Login = () => {
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const handleRedirect = async () => {
            try {
                const response = await msalInstance.handleRedirectPromise();
                const account = response?.account ?? msalInstance.getAllAccounts()[0];
                if (account) {
                    msalInstance.setActiveAccount(account);
                }
            } catch (error) {
                console.error("Redirect handling failed:", error);
            }
        };

        handleRedirect();
    }, []);

    const loginWithRedirect = () => {
        msalInstance.loginRedirect({
            scopes: loginRequest.scopes,
        });
    };

    return (
        <div style={containerStyle}>
            <h2 style={headerStyle}>Welcome</h2>
            <button
                onClick={loginWithRedirect}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    ...buttonStyle,
                    ...(isHovered ? buttonHoverStyle : {})
                }}
            >
                <img src={microsoftLogo} alt="Microsoft Logo" style={logoStyle} />
                Login with Microsoft
            </button>
        </div>
    );
};

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column' as 'column', // Explicit type assertion
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    fontFamily: 'Arial, sans-serif',
};

const headerStyle: CSSProperties = {
    color: '#333',
    fontSize: '24px',
    marginBottom: '20px',
};

const buttonStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#2F2F8D',
    color: 'white',
    fontWeight: 'bold',
    padding: '12px 24px',
    fontSize: '16px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    transition: 'background-color 0.3s, transform 0.3s',
};

const buttonHoverStyle: CSSProperties = {
    backgroundColor: '#1A1A73',
    transform: 'scale(1.05)',
};

const logoStyle: CSSProperties = {
    width: '20px',
    height: '20px',
    marginRight: '12px',
};

export default Login;
